import { useConnectionStore } from '@/stores/connectionStore';
import { useRouter } from 'vue-router';
import axios from "axios";

import { CapacitorHttp } from '@capacitor/core';

const contaboWebsiteURL = "https://www.chessvis.com/"
//const developmentWebsiteURL = contaboWebsiteURL
const developmentWebsiteURL = "http://chessvis.ddns.net:8888/"

//const developmentWebsiteURL = "http://chessvis.ddns.net/"
//const developmentWebsiteURL = "http://192.168.1.11/"

// https://stackoverflow.com/questions/38241480/detect-macos-ios-windows-android-and-linux-os-with-js

export const getOS = (returnIndex) => {
  var userAgent = window.navigator.userAgent,
      platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K',"macOS"],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;
  var index = "4"

  //console.log("**** PLATFORM " + platform)
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
    index = "14"
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
    index = "15"
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
    index = "16"
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
    index = "17"
  } else if (/Linux/.test(platform)) {
    os = 'Linux';
    index = "18"
  }

  if (returnIndex)
    return (index)

  return os;
}

export function getWebSiteURL() {
  var websiteURL = (process.env.NODE_ENV === 'production') ? contaboWebsiteURL : developmentWebsiteURL

  // force development
  //websiteURL = developmentWebsiteURL

  // force production
  //websiteURL = contaboWebsiteURL

  // Note: IOS thinks it is production

  //return (developmentWebsiteURL)
  
  //return (contaboWebsiteURL)
  return (websiteURL)
}

export function useGetData(programName, fieldData, processJsonResponse) {

  const websiteURL = getWebSiteURL()


  // convert the POST data from the calling program into a JSON object.
  // then add the "builtins" - cookie, dummy, calltype and platform (cook = 4) which is the "web"

  var postData = JSON.parse(JSON.stringify(fieldData))

  const connectionStore = useConnectionStore()
  const cookie = connectionStore.getCookie
  const dummy = connectionStore.getDummy

  postData.cookie = cookie
  postData.dummyUser = dummy
  postData.calltype = "2"
  postData.cook = getOS(true)          // 4=new web, 8=eye gaze
  postData.prg = programName

  //const useProgramName = "run_it.php"
  //const URL = websiteURL + useProgramName
  const URL = websiteURL + programName

  //console.log("**** postdata (getdata)",postData)
  //console.log("website  ",URL)

  /*
  const doPost = () => {
    const options = {
      url: 'https://example.com/my/api',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: postData,
    };
  
    const response = await CapacitorHttp.post(options);
  
    //console.log("**** CAPACITOR RESPONSE",response)
    // or...
    // const response = await CapacitorHttp.request({ ...options, method: 'POST' })
  };
  */
  
  var optionAxios = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
  axios.post(URL,postData,optionAxios)
    .then(
      response => {

        // this shows the JSON coming back from the server
        //console.log(response)

        //console.log("**** after response data.  cookie ",cookie)

        // check the cookie before going back to the calling routine
        if (cookie == "") {
          //console.log("in new cookie")
          const jsonCookie = response.data.hasOwnProperty("cookie") ? response.data['cookie'] : null
          const jsonDummy = response.data.hasOwnProperty("dummy") ? response.data['dummy'] : null
          //console.log("before if", jsonCookie, jsonDummy)
          if (jsonCookie != null && jsonDummy != null) {
            //console.log("set cookie (usegetdata)",jsonCookie,jsonDummy)
            connectionStore.setUserCookieDummy(jsonCookie,jsonDummy)            
          }
        }
        //console.log("In Getdata good data")
        processJsonResponse(response.data);
      }
    )
    .catch(error => {
      const errorJson = { "error" : error , "programRun" : programName}
      //console.log("In Getdata error -> ",errorJson)
      processJsonResponse(errorJson);
    })
    
}

// special getdata for use by startup because it will have a callback into the initiating routine
export function useGetDataStartup(programName, fieldData, processJsonResponse,afterProcessingCallbackRoutine) {

  //const websiteURL = (process.env.NODE_ENV === 'production') ? contaboWebsiteURL : developmentWebsiteURL

  const websiteURL = getWebSiteURL()

  //console.log("website  ",websiteURL)

  // convert the POST data from the calling program into a JSON object.
  // then add the "builtins" - cookie, dummy, calltype and platform (cook = 4) which is the "web"

  var postData = JSON.parse(JSON.stringify(fieldData))

  const connectionStore = useConnectionStore()
  const cookie = connectionStore.getCookie
  const dummy = connectionStore.getDummy

  //console.log("in getdata startup cookie",cookie,dummy)
  postData.cookie = cookie
  postData.dummyUser = dummy
  postData.calltype = "2"
  postData.cook = getOS(true)           // 4=new web, 8=eye gaze
  postData.prg = programName

  //const useProgramName = "run_it.php"
  //const URL = websiteURL + useProgramName
  const URL = websiteURL + programName


  //console.log("**** postdata (startup) ",postData)
  var optionAxios = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
  axios.post(URL,postData,optionAxios)
    .then(
      response => {

        // this shows the JSON coming back from the server
        //console.log(response)

        //console.log("**** after response data.  cookie ",cookie)

        // check the cookie before going back to the calling routine
        if (cookie == "") {
          //console.log("in new cookie")
          const jsonCookie = response.data.hasOwnProperty("cookie") ? response.data['cookie'] : null
          const jsonDummy = response.data.hasOwnProperty("dummy") ? response.data['dummy'] : null
          //console.log("before if", jsonCookie, jsonDummy)
          if (jsonCookie != null && jsonDummy != null) {
            //console.log("set cookie (startup)",jsonCookie,jsonDummy)
            connectionStore.setUserCookieDummy(jsonCookie,jsonDummy)            
          }
        }
        //console.log("In Getdata for startup routine")
        processJsonResponse(response.data,afterProcessingCallbackRoutine);
      }
    )
    .catch(error => {
      const errorJson = { "error" : error , "programRun" : programName}
      //console.log("In Getdata error -> ",errorJson)
      processJsonResponse(errorJson,afterProcessingCallbackRoutine);
    })
}

// https://stackoverflow.com/questions/5684303/javascript-window-open-pass-values-using-post

export function useGetDataDownload(programName, fieldData) {

  //const websiteURL = (process.env.NODE_ENV === 'production') ? contaboWebsiteURL : developmentWebsiteURL

  const websiteURL = getWebSiteURL()

  //console.log("website  ",websiteURL)

  // convert the POST data from the calling program into a JSON object.
  // then add the "builtins" - cookie, dummy, calltype and platform (cook = 4) which is the "web"

  var postData = JSON.parse(JSON.stringify(fieldData))

  const connectionStore = useConnectionStore()
  const cookie = connectionStore.getCookie
  const dummy = connectionStore.getDummy

  postData.cookie = cookie
  postData.dummyUser = dummy
  postData.calltype = "2"
  postData.cook = getOS(true)           // 4=new web, 8=eye gaze
  postData.prg = programName

  // const useProgramName = "run_it.php"
  // const URL = websiteURL + useProgramName
  const URL = websiteURL + programName

  var form = document.createElement("form");
  form.target = "_blank";
  form.method = "POST";
  form.action = URL;
  form.style.display = "none";

  for (var key in postData) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = postData[key];
      form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);

}

// set fieldData to null for a "get" call

export function getLichessData(lichessURL, accessToken,fieldData, processJsonResponse) {

  // set accessToken to "pgn" when downloading games

  //const accessToken1 = "lip_J07IAf4R0NUi2viunntt"

  //console.log("**** access token",accessToken)

  var optionAxios = {
    headers: {
        'Accept' : (accessToken == "pgn") ? 'x-chess-pgn' : 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
    }
  }

  // some calls like to see if the token is valid don't need a Bearer Token
  
  if (accessToken != null && accessToken != "pgn")
    optionAxios.headers.Authorization = "Bearer " + accessToken

  // if fieldData is set to null then do a "GET"

  if (fieldData == null) {
    //console.log("######## GET call")
    axios.get(lichessURL,optionAxios)
    .then(
      response => {

        // this shows the JSON coming back from the server
        //console.log("JSON back from Lichess",response)
        processJsonResponse(response.data);
      }
    )
    .catch(error => {
      const errorJson = { "error" : error , "programRun" : lichessURL}
      //console.log("In getLichess error -> ",errorJson)
      processJsonResponse(errorJson);
    })
  }
  else {
    // convert the POST data from the calling program into a JSON object.
    var postData = JSON.parse(JSON.stringify(fieldData))

    //console.log("**** postdata ",postData)

    axios.post(lichessURL,postData,optionAxios)
      .then(
        response => {

          // this shows the JSON coming back from the server
          //console.log("JSON back from Lichess",response)
          processJsonResponse(response.data);
        }
      )
      .catch(error => {
        const errorJson = { "error" : error , "programRun" : lichessURL}
        //console.log("In getLichess error -> ",errorJson)
        processJsonResponse(errorJson);
      })
  }
}

// set fieldData to null for a "get" call

export function getChesscomData(chesscomURL,fieldData, processJsonResponse) {

  var optionAxios = {
    // headers: {
    //     'User-Agent': 'Chessvis henry@chessvis.com'
    // }
  }

  // if fieldData is set to null then do a "GET"

  if (fieldData == null) {
    //console.log("######## GET call")
    axios.get(chesscomURL,optionAxios)
    .then(
      response => {

        // this shows the JSON coming back from the server
        //console.log("JSON back from Lichess",response)
        processJsonResponse(response.data);
      }
    )
    .catch(error => {
      const errorJson = { "error" : error , "programRun" : chesscomURL}
      //console.log("In chesscom get error -> ",errorJson)
      processJsonResponse(errorJson);
    })
  }
  else {
    // convert the POST data from the calling program into a JSON object.
    var postData = JSON.parse(JSON.stringify(fieldData))

    //console.log("**** postdata ",postData)

    axios.post(chesscomURL,postData,optionAxios)
      .then(
        response => {

          // this shows the JSON coming back from the server
          //console.log("JSON back from chesscom",response)
          processJsonResponse(response.data);
        }
      )
      .catch(error => {
        const errorJson = { "error" : error , "programRun" : chesscomURL}
        //console.log("In getChesscom error -> ",errorJson)
        processJsonResponse(errorJson);
      })
  }
}

/*

void show_io_error(Exception e, JsonObject result, String code) {
        String top = get_string_by_name("ion_error_top");
        String bottom = get_string_by_name("ion_error_bottom");
        String bottom_reference = get_string_by_name("ion_error_bottom_reference");

        String middle;
        if (e != null)
            middle = e.toString();
        else
            middle = result.get("error").getAsString();
        SimpleDialog.with(this).showAlertDialog(top + "\n-----------------------------------\n" +  middle + "\n-----------------------------------\n" + bottom + "\n\n" + bottom_reference + " : " + code);
    }


*/

export function generateErrorAlertText(json) {
  const iosTop = "Chessvis had the following error while communicating with its on-line server"
  const iosBottom = "If this persists and is not associated with your connectivity, please let us know at: support@chessvis.com"

  const message = iosTop + ":     " + json['programRun'] + "     " + json['error']
                  + "       " + iosBottom
  const header = "Communications Error"
  const type = "alert"
  const task = "commError"

  const alertInfo = { header : header, message : message, type : type, task : task  }
  return (alertInfo)
}

export function Utf8ArrayToStr(array) {
    var out, i, len, c;
    var char2, char3;

    out = "";
    len = array.length;
    i = 0;
    while(i < len) {
    c = array[i++];
    switch(c >> 4)
    { 
      case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12: case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode(((c & 0x0F) << 12) |
                       ((char2 & 0x3F) << 6) |
                       ((char3 & 0x3F) << 0));
        break;
      }
    }
    return out;
  }
  